import { render } from "./EstimatedSavingsDialog.vue?vue&type=template&id=02da8a48"
import script from "./EstimatedSavingsDialog.vue?vue&type=script&lang=js"
export * from "./EstimatedSavingsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/EstimatedSavingsDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02da8a48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02da8a48', __exports__)) {
    api.reload('02da8a48', __exports__)
  }
  
  module.hot.accept("./EstimatedSavingsDialog.vue?vue&type=template&id=02da8a48", () => {
    api.rerender('02da8a48', render)
  })

}


export default __exports__